module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/pro/depreciation/depreciation-show/depreciation-show.component.scss
// module id = ./src/app/views/pro/depreciation/depreciation-show/depreciation-show.component.scss
// module chunks = main